import * as React from 'react';

import { Limit } from '../../../components/admin/Limit';
import { useSelector } from 'react-redux';
import { selectLimit } from 'shared/selectors/admin/limit';
import { useAppDispatch } from 'shared/hooks';
import { setLimit } from 'shared/slices/admin/limit/limitSlice';
import { loadProjects } from 'shared/thunks/admin';
import { setPage } from 'shared/slices/admin/page/pageSlice';

export const LimitContainer: React.FC = () => {
  const limit = useSelector(selectLimit);

  const dispatch = useAppDispatch();

  const onChange = React.useCallback(
    (limit: number) => {
      dispatch(setLimit(limit));
      dispatch(setPage(1));
      dispatch(loadProjects());
    },
    [dispatch],
  );

  return <Limit limit={limit} onChange={onChange} />;
};
